import { jsx, jsxs } from 'react/jsx-runtime';
import { useGlobalSearchSetValue, defaultSearchBarValue } from '../../search/hooks/hybridsearch.js';
import { Button } from '@fabric-app/ui/components/Button';
import { useShowExpandedResource } from '../../resources/stores/useExpandedResourceStore.js';
import { useSearchOverlay } from '../../search/hooks/useSearchOverlay.js';
import { useResourceLoadingStateIndicatorProps } from '../../resources/components/StateSpinner.js';
import Tooltip from '@fabric-app/ui/components/Tooltip';
import { IconNavigational24Similar } from '@fabric-app/icons/svg';

const ButtonShowSimilar = ({ resource, onClick }) => {
  const { isIndexing } = useResourceLoadingStateIndicatorProps(resource);
  const { openOverlay } = useSearchOverlay();
  const showExpandedResource = useShowExpandedResource();
  const setSearchBarValue = useGlobalSearchSetValue();
  return /* @__PURE__ */ jsx(Tooltip, {
    label: "This item is currently being indexed.",
    offset: 12,
    disabled: !isIndexing,
    children: /* @__PURE__ */ jsxs(Button, {
      variant: "bg-secondary",
      disabled: isIndexing,
      onClick: () => {
        setSearchBarValue({
          ...defaultSearchBarValue,
          similarToResource: resource
        });
        openOverlay("global", {
          onCloseOverlayOnce: () => {
            showExpandedResource(resource);
            setSearchBarValue((prev) => ({
              ...prev,
              similarToResource: null
            }));
          }
        });
        onClick?.();
      },
      children: [
        /* @__PURE__ */ jsx(IconNavigational24Similar, {}),
        " Show similar"
      ]
    })
  });
};

export { ButtonShowSimilar };
//# sourceMappingURL=ButtonShowSimilar.js.map
